import { createSlice } from "@reduxjs/toolkit";
import { doFetchBookingList } from "./booking.action";
import { Meta, SessionBooking } from "../types";

interface BookingState {
  bookings: SessionBooking[];
  meta: Meta | null;
  loading: boolean;
  error: string | null;
}
const initialState: BookingState = {
  bookings: [],
  meta: null,
  loading: false,
  error: null,
};

export const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(doFetchBookingList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchBookingList.fulfilled, (state, action) => {
        state.loading = false;
        state.bookings = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(doFetchBookingList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});


export default bookingSlice.reducer;
